import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import ParkingTypes from './data/parkingTypes';
import ParkingTypeFields from './ParkingTypeFields';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const ParkingFields = ({ parkingToggleFieldValue, intl }) => {

  return (
    <div>
      <div className="flex column">
        <h2 className="">
          <FormattedMessage
            id="hosting.parking_fields.parking_options_header"
            defaultMessage="Describe the parking options"
          />
        </h2>
        <div className="flex flex-start column-sm space-between text-large">
          <span className="margin-md-right">
            <FormattedMessage
              id="hosting.parking_fields.parking_options_label"
              defaultMessage="Are there parking options at or near your space?"
            /></span>
          <div className="toggle-field">
            <Field
              name='is_available'
              className="flex"
              component={ToggleField}
              attributes={{
                'data-testing-id': 'has-parking-toggle',
                name: 'is_available'
              }}
              firstOption={
                {
                  id: 'has-parking-true',
                  value: 'true',
                  label: (<FormattedMessage
                    id="hosting.parking_fields.has_parking_true"
                    defaultMessage="Yes"
                  />)
                }}
              secondOption={
                {
                  id: 'has-parking-false',
                  value: 'false',
                  label: (
                    <FormattedMessage
                      id="hosting.parking_fields.has_parking_false"
                      defaultMessage="No"
                    />)
                }}
              defaultValue="true"
            />
          </div>
        </div>
      </div>
      {
        'true' === parkingToggleFieldValue
        && (
          <div>
            <h6 className="margin-lg-top">
              <FormattedMessage
                id="hosting.parking_fields.select_all_heading"
                defaultMessage="Select all that apply"
              /></h6>
            <div>
              <FieldArray
                name="types"
                component={ParkingTypeFields}
                fields={ParkingTypes}
                errorMessage={
                  <FormattedMessage
                    id="hosting.parking_fields.error_message"
                    defaultMessage="Please select an option"
                  />}
              />
            </div>
            <h6>
              <FormattedMessage
                id="hosting.parking_fields.parking_description_heading"
                defaultMessage="Write a description of the parking options"
              /></h6>
            <p className="text-gray-600">
              <FormattedMessage
                id="hosting.parking_fields.parking_description_text"
                defaultMessage="Don’t include private information. This will be shown publicly."
              /></p>
            <Field
              name="description"
              attributes={{
                'data-testing-id': 'parking-description'
              }}
              component={TextAreaField}
              placeholder={intl.formatMessage({ id: 'hosting.parking_fields.parking_description_placeholder', defaultMessage: 'How many cars can fit?\nHow difficult is street parking?\nHow close are nearby lots etc?' })}
            />
            <div className="flex end">
              <p className="text-gray-600 margin-md-top">
                <FormattedMessage
                  id="hosting.parking_fields.minimum_characters"
                  defaultMessage="Minimum 35 characters"
                /></p>
            </div>
          </div>
        )
      }
    </div>
  );
};

ParkingFields.propTypes = {
  parkingToggleFieldValue: PropTypes.string,
  intl: intlShape
};

export default injectIntl(ParkingFields);
